import { allTrackers } from "app/services/track/track";

import * as SC from "./styles";

const AI_STUDIO_URL = "https://data-studio.similarweb.com/";
const DATA_AUTOMATION_BUTTON = "ai-studio-sidebar-button";

type AiStudioButtonProps = {
    isCollapsed: boolean;
};

const AiSparkIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
    >
        <defs>
            <linearGradient
                id="ai-studio-grad"
                x1="0"
                y1="0.5"
                x2="1"
                y2="0.5"
            >
                <stop
                    offset="0%"
                    stopColor="#3e74fe"
                />
                <stop
                    offset="100%"
                    stopColor="#2ad3ab"
                />
            </linearGradient>
            <linearGradient
                id="ai-studio-grad-hover"
                x1="0"
                y1="0.5"
                x2="1"
                y2="0.5"
            >
                <stop
                    offset="0%"
                    stopColor="#3969e0"
                />
                <stop
                    offset="100%"
                    stopColor="#24bd98"
                />
            </linearGradient>
        </defs>
        <path
            fill="url(#ai-studio-grad)"
            d="m13.09 5.895-.908-2.027-2-.92 2-.922L13.09 0 14 2.026l2 .921-2 .921zM5.819 14 4 9.947 0 8.105l4-1.842 1.818-4.052 1.818 4.052 4 1.842-4 1.842zm0-3.574.727-1.584 1.564-.737-1.564-.737-.727-1.584-.727 1.584-1.564.737 1.564.737z"
        />
    </svg>
);

export const AiStudioButton = ({ isCollapsed }: AiStudioButtonProps) => {
    const onButtonClick = () => {
        allTrackers.dispatchTrackEvent("side menu", "click", "ai studio");
        window.open(AI_STUDIO_URL, "_blank", "noopener,noreferrer");
    };

    return (
        <SC.Wrapper
            isCollapsed={isCollapsed}
            onClick={onButtonClick}
            data-automation={DATA_AUTOMATION_BUTTON}
        >
            <SC.IconWrapper isCollapsed={isCollapsed}>
                <AiSparkIcon />
            </SC.IconWrapper>

            <SC.Text isCollapsed={isCollapsed}>AI Studio</SC.Text>
        </SC.Wrapper>
    );
};
